import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

interface Props {
  space?: boolean;
  verticalCenter?: boolean;
  apart?: boolean;
  wrap?: boolean;
}


export default /*@__PURE__*/_defineComponent({
  __name: 'Row',
  props: {
    space: { type: Boolean },
    verticalCenter: { type: Boolean },
    apart: { type: Boolean },
    wrap: { type: Boolean }
  },
  setup(__props: any) {

const props = __props;

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["flex", [
    props.space ? 'gap-4' : 'gap-2', {
      'flex-wrap': props.wrap,
      'items-center': props.verticalCenter,
      'justify-between': props.apart,
    }]])
  }, [
    _renderSlot(_ctx.$slots, "default")
  ], 2 /* CLASS */))
}
}

})